import { vars } from '../../theme';
import React from 'react';
import HBBannerBase from '../HBBanner/HBBannerBase';
import { ExclamationMarkTriangle24 } from '@honeybook/icons';
import { HBBannerProps } from '../HBBanner/HBBanner.types';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';

export interface Props extends Omit<HBBannerProps, 'hideIcon'> {
    /** HBButton theme for the primary action. 'secondary-solid-secondary' for a filled secondary button; 'button-link' for a link-style action. */
    primaryActionTheme?: 'secondary-solid-secondary' | 'button-link';
}

const ErrorBanner = (props: Props & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <HBBannerBase
            icon={ExclamationMarkTriangle24}
            primaryActionTheme="secondary-solid-secondary"
            {...props}
            accentLine={vars.colors.base.danger}
            background={vars.colors.surface.danger}
        />
    );
};

export default ErrorBanner;
